(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (() => {
  const initCountdowns = () => {
    const countdowns = document.querySelectorAll('[data-countdown]');

    countdowns.forEach((countdown) => {
      // Evita inicializar duas vezes
      if (countdown.dataset.initialized === 'true') return;
      countdown.dataset.initialized = 'true';

      let endValue = countdown.dataset.end;

      if (!endValue) {
        console.warn('Countdown: data-end vazio');
        return;
      }

      // Remove espaços extras
      endValue = endValue.trim().replace(/\s+/g, ' ');

      // Aceita DD/MM/AAAA HH:MM (com ou sem zero à esquerda)
      const match = endValue.match(
        /^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})$/
      );

      if (!match) {
        console.warn(
          'Countdown: formato inválido. Use DD/MM/AAAA HH:MM. Exemplo: 25/09/2026 23:59'
        );
        console.warn('Valor recebido:', endValue);
        return;
      }

      const day = parseInt(match[1], 10);
      const month = parseInt(match[2], 10);
      const year = parseInt(match[3], 10);
      const hour = parseInt(match[4], 10);
      const minute = parseInt(match[5], 10);

      // Mês no JS começa em 0
      const targetDate = new Date(year, month - 1, day, hour, minute, 0);

      if (isNaN(targetDate.getTime())) {
        console.warn('Countdown: data inválida →', endValue);
        return;
      }

      const daysElement = countdown.querySelector('[data-days]');
      const hoursElement = countdown.querySelector('[data-hours]');
      const minutesElement = countdown.querySelector('[data-minutes]');
      const secondsElement = countdown.querySelector('[data-seconds]');

      const expiredElement = countdown.parentElement?.querySelector(
        '[data-countdown-expired]'
      );

      const updateCountdown = () => {
        const now = new Date();
        const difference = targetDate.getTime() - now.getTime();

        if (difference <= 0) {
          countdown.hidden = true;
          if (expiredElement) {
            expiredElement.hidden = false;
          }
          clearInterval(countdown._interval);
          return;
        }

        const totalSeconds = Math.floor(difference / 1000);

        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (daysElement) {
          daysElement.textContent = String(days).padStart(2, '0');
        }
        if (hoursElement) {
          hoursElement.textContent = String(hours).padStart(2, '0');
        }
        if (minutesElement) {
          minutesElement.textContent = String(minutes).padStart(2, '0');
        }
        if (secondsElement) {
          secondsElement.textContent = String(seconds).padStart(2, '0');
        }
      };

      // Atualiza imediatamente
      updateCountdown();

      // Guarda o interval no próprio elemento para poder limpar depois
      countdown._interval = setInterval(updateCountdown, 1000);
    });
  };

  // Roda no carregamento normal da página
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdowns);
  } else {
    initCountdowns();
  }

  // Importante para o Theme Editor e seções dinâmicas
  document.addEventListener('shopify:section:load', initCountdowns);
  document.addEventListener('shopify:section:reorder', initCountdowns);
})();
  } catch(e) { console.error(e); }
})();

})();
